const PaymentListingState = (function states() {
    return {
        labelList: [],
    }
})()

export default PaymentListingState;